import { useState } from "react";
import {
  Input,
  Button,
  FormField,
  Select,
  SpaceBetween,
  Form,
  Container,
  ColumnLayout,
  Header,
  Box,
} from "@cloudscape-design/components-themed";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hook";
import { isHalfNumberValid, isLengthValid } from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";
import { createCounselingSearchCondition } from "../../features/slices/counselings-search";
import { LABELS, NEGOTIATION_STATUS_LIST, PLACE_HOLDERS } from "./constants";
import { COMMON_LABELS } from "../default-constants";

const SearchBar = () => {
  // 法人番号
  const [corporateNumber, setCorporateNumber] = useState("");
  const [corporateNumberErrorMsg, setCorporateNumberErrorMsg] = useState("");

  // 事業者名
  const [companyName, setCompanyName] = useState("");
  const [companyNameErrorMsg, setCompanyNameErrorMsg] = useState("");

  // 交渉状況
  const [negotiationStatus, setNegotiationStatus] = useState({ value: "" });

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  // 検索ボタンイベント
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // イベントキャンセル
    e.preventDefault();

    // Validate
    if (
      !checkCompanyName(companyName) ||
      !checkCorporateNumber(corporateNumber)
    ) {
      return;
    }

    dispatch(
      createCounselingSearchCondition({
        corporateNumber: corporateNumber,
        companyName: companyName,
        negotiationStatus: negotiationStatus.value,
        timestamp: new Date().getTime(),
      })
    );
  };

  // 事業者名バリデーションチェック
  const checkCompanyName = (companyName: string): boolean => {
    if (!isLengthValid(companyName, 30)) {
      setCompanyNameErrorMsg(getMessage("KGRERR058", 30).label);
      return false;
    } else {
      setCompanyNameErrorMsg("");
      return true;
    }
  };

  // 法人番号バリデーションチェック
  const checkCorporateNumber = (corporateNumber: string): boolean => {
    if (!isHalfNumberValid(corporateNumber)) {
      setCorporateNumberErrorMsg(
        getMessage("KGRERR006", LABELS.CORPORATE_NUMBER).label
      );
      return false;
    } else if (!isLengthValid(corporateNumber, 13)) {
      setCorporateNumberErrorMsg(getMessage("KGRERR058", 13).label);
      return false;
    } else {
      setCorporateNumberErrorMsg("");
      return true;
    }
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal">{COMMON_LABELS.BTNS.SEARCH}</Button>
          </SpaceBetween>
        }
      >
        <Container
          header={
            <SpaceBetween direction="vertical" size="xs">
              <Box variant="small" color="text-status-error">
                {LABELS.REGISTRATION_ATTENTION}
              </Box>
              <Button
                onClick={() => {
                  navigate("/individual-counseling-project/regist");
                }}
                formAction="none"
              >
                {LABELS.BTN_REGISTER}
              </Button>
            </SpaceBetween>
          }
        >
          <SpaceBetween direction="vertical" size="l">
            <Header>{LABELS.SEARCH_TITLE}</Header>
            <ColumnLayout columns={4}>
              <FormField
                label={LABELS.CORPORATE_NUMBER}
                errorText={corporateNumberErrorMsg}
                constraintText="半角数字13桁以内"
              >
                <Input
                  name="corporateNumber"
                  value={corporateNumber}
                  onChange={(e) => {
                    setCorporateNumber(e.detail.value);
                    checkCorporateNumber(e.detail.value);
                  }}
                />
              </FormField>
              <FormField
                label={LABELS.COMPANY_NAME}
                errorText={companyNameErrorMsg}
                constraintText="30文字以内"
              >
                <Input
                  name="companyName"
                  value={companyName}
                  placeholder={PLACE_HOLDERS.CORP_NAME}
                  onChange={(e) => {
                    setCompanyName(e.detail.value);
                    checkCompanyName(e.detail.value);
                  }}
                />
              </FormField>
              <FormField label={LABELS.NEGOTIATION_STATUS}>
                <Select
                  selectedOption={negotiationStatus}
                  options={NEGOTIATION_STATUS_LIST}
                  filteringType="none"
                  onChange={(event: any) => {
                    setNegotiationStatus(event.detail.selectedOption);
                  }}
                />
              </FormField>
            </ColumnLayout>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default SearchBar;
